import {NgModule} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {SharedModule} from '../../app-common/shared.module';
import {bookingV2RoutingComponents, BookingV2RoutingModule} from './booking-v2-routing.module';
import {BookingV2StateService} from './services/booking-v2-state.service';
import {BookingV2ManagerService} from './services/booking-v2-manager.service';
import {BookingV2DataService} from './services/booking-v2-data.service';
import {BookingV2ApiService} from './services/booking-v2-api.service';
import {BookingV2RouteResolverService} from './services/booking-v2-route-resolver.service';
import {BookingHeaderDesktopComponent} from './components/booking-header-desktop/booking-header-desktop.component';
import {BookingV2UrlBuilderService} from './services/booking-v2-url-builder.service';
import {BookingHeaderMobileComponent} from './components/booking-header-mobile/booking-header-mobile.component';
import {StepperHeaderComponent} from './components/stepper-header-v2/stepper-header.component';
import {BookingCardHeaderComponent} from './components/booking-card-header/booking-card-header.component';
import {PriceInfoComponent} from './components/price-info/price-info.component';
import {BookingFooterComponent} from './components/booking-footer/booking-footer.component';
import {BookingSummaryComponent} from './components/booking-summary/booking-summary.component';
import {ServiceSectionV2Component} from './components/service-section-v2/service-section-v2.component';
import {SeeMoreDirective} from './directives/see-more.directive';
import {BookingV2EdgeCasesService} from './services/booking-v2-edge-cases.service';
import {CalendarSectionV2Component} from './components/calendar-section-v2/calendar-section-v2.component';
import {WeekPickerV2Component} from './components/week-picker-v2/week-picker-v2.component';
import {NoSlotsAvailableAtAllComponent} from './components/alerts/no-slots-available-at-all/no-slots-available-at-all.component';
import {NoSlotsAvailableDoctorComponent} from './components/alerts/no-slots-available-doctor/no-slots-available-doctor.component';
import {NoSlotsAvailableRedirectedComponent} from './components/alerts/no-slots-available-redirected/no-slots-available-redirected.component';
import {NoSlotsAvailableSelectDoctorComponent} from './components/alerts/no-slots-available-select-doctor/no-slots-available-select-doctor.component';
import {DatePickerV2Component} from './components/date-picker-v2/date-picker-v2.component';
import {SubmitSectionComponent} from './components/submit-section/submit-section.component';
import {SurveyV2Component} from './components/survey-v2/survey-v2.component';
import {BookingV2SurveyService} from './services/booking-v2-survey.service';
import {VdRadioComponent} from './components/form-components/vd-radio/vd-radio.component';
import {VdMultiselectComponent} from './components/form-components/vd-multiselect/vd-multiselect.component';
import {BookingV2ErrorHandlerService} from './services/booking-v2-error-handler.service';
import {CareproviderUnitService} from '../../services/careprovider-unit.service';
import {TreatmentsDropdownComponent} from './components/treatments-dropdown/treatments-dropdown.component';
import {NoSlotsAvailableNext90DaysComponent} from './components/alerts/no-slots-available-next-90-days/no-slots-available-next-90-days.component';
import {NoSlotsAvailableNext30DaysComponent} from './components/alerts/no-slots-available-next-30-days/no-slots-available-next-30-days.component';
import {NoSlotsAvailableNoMatchComponent} from './components/alerts/no-slots-available-no-match/no-slots-available-no-match.component';
import {StepperIconsComponent} from './components/stepper-icons/stepper-icons.component';
import {BankidSectionComponent} from './components/bankid-section/bankid-section.component';
import {QRCodeModule} from 'angularx-qrcode';
import {BookingFaqComponent} from './components/booking-faq/booking-faq.component';
import {UiIconButtonComponent} from '../../components/ui/ui-icon-button/ui-icon-button.component';
import {UiButtonComponent} from '../../components/ui/ui-button/ui-button.component';
import {UiIconComponent} from '../../components/ui/ui-icon/ui-icon.component';

@NgModule({
  declarations: [
    bookingV2RoutingComponents,
    BookingHeaderDesktopComponent,
    BookingHeaderMobileComponent,
    BookingCardHeaderComponent,
    BookingFooterComponent,
    BookingSummaryComponent,
    StepperHeaderComponent,
    PriceInfoComponent,
    ServiceSectionV2Component,
    SeeMoreDirective,
    CalendarSectionV2Component,
    WeekPickerV2Component,
    DatePickerV2Component,
    SubmitSectionComponent,
    SurveyV2Component,
    NoSlotsAvailableAtAllComponent,
    NoSlotsAvailableDoctorComponent,
    NoSlotsAvailableRedirectedComponent,
    NoSlotsAvailableSelectDoctorComponent,
    VdRadioComponent,
    VdMultiselectComponent,
    NoSlotsAvailableNext90DaysComponent,
    NoSlotsAvailableNext30DaysComponent,
    TreatmentsDropdownComponent,
    BookingFaqComponent,
    NoSlotsAvailableNoMatchComponent,
    StepperIconsComponent,
    BankidSectionComponent,
  ],
  imports: [
    SharedModule,
    BookingV2RoutingModule,
    MatTooltipModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatExpansionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    QRCodeModule,
    UiIconButtonComponent,
    UiButtonComponent,
    UiIconComponent,
  ],
  providers: [
    BookingV2StateService,
    BookingV2ManagerService,
    BookingV2DataService,
    BookingV2ApiService,
    BookingV2RouteResolverService,
    BookingV2UrlBuilderService,
    BookingV2EdgeCasesService,
    BookingV2SurveyService,
    BookingV2ErrorHandlerService,
    CareproviderUnitService,
    BookingV2ApiService,
  ],
  exports: [],
})
export class BookingV2Module {}
